<template>
    <!--我的地址页面-->
    <div class="prdListWrap">
        <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore"  distance-index="1" bottom-distance="200">
            <!-- <ul>
                <li > -->
                    <div class="adressBox clearfix" v-for="(item,index) in myadrList" :key="index">

                        <!--icon-dui-->
                        <div class="chooseBtn fl" @click="chooseAdr(index,item.id)">
                            <!--<p class="iconfont icon-dui" v-show="chooseadr"></p>-->
                            <!--<span class="unchoose" v-show="!chooseadr"></span>-->
                            <!--<p class="iconfont icon-dui" v-show="chooseadr"></p>-->
                            <span class="iconfont" :class="{'icon-dui': item.id==chooseadr,'unchoose':item.id==chooseadr?false:true}"></span>
                        </div>
                        <div class="addrDel fl">
                            <p class="namePhone clearfix">
                                <span class="userName oneEllipsis fl" v-text="item.addressee"></span>
                                <span class="userPhone fr" v-text="item.phone"></span>
                            </p>
                            <p class="addrText twoEllipsis" v-text="item.address"></p>
                        </div>
                        <!--点击进入编辑地址-->
                        <div class="editMyadr fr" @click="editThisAdr(item)">
                            <p class="iconfont icon-bi1 boxSizing"></p>
                        </div>

                    </div>
                <!-- </li>
            </ul> -->
        </mt-loadmore>
        <div class="noDataAddr" v-if="noDataAddr">您还没有设置地址，快去设置吧！</div>
        <div class="room"></div>

        <!--新增地址按钮-->
        <div class="newAdr">
            <!--<router-link class="newAdrBtn" :to="{path:'addr',query:{id:}}"><span class="iconfont icon-jia"></span>新增地址</router-link>-->
            <div class="newAdrBtn" @click="addNewAdr"><span class="iconfont icon-jia"></span>新增地址</div>
        </div>

    </div>
</template>

<script>

    import axios from "axios";
    import qs from "qs";
    import common from "../common";
    import { Loadmore } from 'mint-ui';
    // import Scroll from '@/components/common/Scroll';

    export default {
        name: "myAddr",
        data() {
            return{
                pageIndex:1,
                pageSize:12,
                myadrList:[],
                chooseadr:'',
                allLoaded:false,
                noDataAddr: true
            }
        },
        created() {
            this.getMyadr();
            common.iflogin();
        },
        methods: {
            //下拉加载
            loadBottom(){
                var that = this;
                that.getMyadr(()=>{
                    that.$refs.loadmore.onBottomLoaded();
                });
            },

            //渲染地址列表数据
            getMyadr( callback ) {
                var that = this;
                axios.post("/wap/AddrHandle/addrList",qs.stringify({ page: that.pageIndex, limit: that.pageSize }))
                    .then(res => {
                        var data=res.data.data;//地址列表

                        if(data.length === 0){
                            this.allLoaded = true;
                        }else{
                            this.noDataAddr = false; //没数据，提示信息
                            this.pageIndex +=1;
                        }

                        for (var i=0;i<data.length;i++){
                            this.myadrList.push(data[i])
                        }
                        // this.addr_id = data.id;
                        // this.addressee = data.addressee;
                        // this.phone = data.phone;
                        // this.address = data.address;

                        callback && (typeof(callback) === "function") && callback();

                    }).catch(error => {

                        console.log(error);

                    });
            },
            //选中地址
            chooseAdr:function (index,id) {
                //如果从订单页进入则可选择地址，从我的地址页面不可
                if(this.$route.query.id){
                    this.chooseadr = id;
                    this.$router.push({
                        path: '/editOrder',
                        query: {
                            id:this.$route.query.id || localStorage.getItem('myaddrId'),
                            index: index
                        }
                    });
                }
            },
            //新增地址
            addNewAdr:function () {
                localStorage.setItem('myaddrId',this.$route.query.id);
                var id = localStorage.getItem("myaddrId");
                // this.$router.push('/addr');
                this.$router.push({path:'/addr',query:{goodsId:id}});
            },
            //编辑该地址
            editThisAdr: function (id) {
                console.log(id);
                id.goodsId = this.$route.query.id;
                this.$router.push({
                    path: '/address',
                    query:  id
                });
            },
        }
    };
</script>

<style scoped lang="scss">
/deep/ .mint-loadmore-text{
    font-size: 30px;
}
.prdListWrap{
     -webkit-overflow-scrolling: touch;
     height:100vh;
    overflow: scroll;
}
    .adressBox{
        height: 200px;
        font-size: 26px;
        border-bottom: 1PX solid #E1E1E1;
        overflow: hidden;
        .chooseBtn{
            width:10%;
            text-align: center;
            line-height: 200px;
            .unchoose{
                /*display: inline-block;*/
                width: 26px;
                height: 26px;
                border: 2PX solid #E1E1E1;
                border-radius:50%;
            }
            .icon-dui{
                color: #FF8B11;
            }
        }
        .addrDel{
            width: 78%;
            .namePhone{
                margin: 46px 0 20px;
                font-size: 30px;
            }
            .addrText{
                color: #666;
            }
        }
        .editMyadr{
            width: 12%;
            height: 200px;
            text-align: center;
            line-height: 200px;
            p{
                font-size: 30px;
            }
            .icon-bi1{
                color: #666;
            }
        }
    }
    .room{
        width: 100%;
        height: 200px;
    }
    .newAdr{
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 120px;
        background: #fff;
        color: #fff;
        font-size: 32px;
        text-align: center;
        .newAdrBtn{
            display: inline-block;
            width: 80%;
            height: 80px;
            line-height: 80px;
            margin-top: 20px;
            color: #fff;
            background: linear-gradient(to bottom, #FFCF5B, #FF8004);
            border-radius: 40px;
            .icon-jia{
                font-size: 50px;
                color: #fff;
                margin-bottom: 3PX;
            }
        }
    }
    .userName{
        display: block;
        width: 64%;
    }
    .noDataAddr{
        height: 600px;
        line-height: 600px;
        text-align: center;
        font-size: 30px;
    }
</style>
